import React from 'react';
import type { EcosystemEntry } from '../../data/ecosystem';
type EcosystemVisualProps = {
  entry: EcosystemEntry;
  size: 'card' | 'hero';
  /** Decorative when the surrounding link or heading already names the entry. */
  decorative?: boolean;
};
const sizes = {
  card: 'w-28 sm:w-32 lg:w-36',
  hero: 'w-48 sm:w-60 lg:w-[22rem]'
};
const wordmarkSizes = {
  card: 'text-3xl lg:text-4xl',
  hero: 'text-5xl lg:text-7xl'
};

/** Approved artwork shown with contain behaviour, or a restrained text wordmark when no artwork exists. */
export function EcosystemVisual({
  entry,
  size,
  decorative = false
}: EcosystemVisualProps) {
  if (entry.image) {
    return <img src={entry.image.src} alt={decorative ? '' : entry.image.alt} className={`${sizes[size]} aspect-square object-contain`} data-id="element-962" data-mp="4hu6592qmbgb" />;
  }
  return <span aria-hidden={decorative || undefined} className={`font-heading font-semibold tracking-tight text-ink-dark ${wordmarkSizes[size]}`} data-id="element-963" data-mp="1yua7pwkl91eu">
      {entry.name}
    </span>;
}